<template>
  <div class="Wafopant">
    <div class="Wafopant-background">
      <div class="appHelmetdwornt">订单详情<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="Wafopant-Recods" v-if="this.waistaon != '0'">
        <div class="Wafopant-Recods-left">
          <p class="Wafopant-Recods-left-content">{{waAdfion.ADDRESS}}</p>
          <p class="Wafopant-Recods-left-title">{{waAdfion.NAME}}<span>{{waAdfion.PHONE}}</span></p>
        </div>
        <div class="Wafopant-Recods-right">
          <img src="../../public/obraoag/Fillrderford.png" alt="">
        </div>
      </div>
      <div class="Wafopant-brder" v-if="this.waistaon != '0'">
        <img src="../../public/obraoag/Fillrderbrder.png" alt="">
      </div>
      <div class="Wafopant-adsncy" v-if="this.waistaon == '0'"></div>
      <div class="Wafopant-Infonbar" v-if="waredots.ORDER_STATE == '0'">请在30分钟内完成支付</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '1'"><span>{{waredots.PLACE_ORDER_DATE}}</span> 已下单,请等待系统确认</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '2'">
        <p><span>{{waredots.PLACE_ORDER_DATE}}</span> 已下单,请等待系统确认</p>
        <p><span>{{waredots.DELIVERY_DATE}}</span> 您的订单已发货完成({{waredots.METHOD_NAME}}{{waredots.METHOD_NUMBER}})</p>
      </div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '3'">订单已取消</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '4'">
        <p><span>{{waredots.PLACE_ORDER_DATE}}</span> 已下单,请等待系统确认</p>
        <p v-if="waredots.shop[0].IS_NOT_COUPONS != '0'"><span>{{waredots.DELIVERY_DATE}}</span> 您的订单已发货完成({{waredots.METHOD_NAME}}{{waredots.METHOD_NUMBER}})</p>
        <p v-if="waredots.shop[0].IS_NOT_COUPONS == '0'"><span>{{waredots.ENTER_DATE}}</span> 您的优惠券已发放到券包</p>
        <p v-else><span>{{waredots.ENTER_DATE}}</span> 订单完成</p>
      </div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '5'">已退款</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '6'">已申请推款</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '7'">已超时</div>
      <div class="Wafopant-Infonbar" v-else-if="waredots.ORDER_STATE == '8'">退款已驳回</div>
      <div class="Wafopant-genspy">
        <div class="Wafopant-stoods">商品清单</div>
        <div class="Wafopant-comdity" v-for="erwalifytr in walifytr" :key="erwalifytr.ID">
          <div class="Wafopant-comdity-left">
            <img :src="erwalifytr.goodsImages" alt="">
          </div>
          <div class="Wafopant-comdity-right">
            <p class="Wafopant-comdity-right-title">{{erwalifytr.GOODS_NAME}}</p>
            <p class="Wafopant-comdity-right-content">规格: {{erwalifytr.SPECIF_NAME}}</p>
            <p class="Wafopant-comdity-right-content">供应商: {{waredots.MERCHANTS_NAME}}</p>
            <div class="Wafopant-comdity-right-Excicent">
              <p class="Wafopant-comdity-right-Excicele" v-if="maluerID == '0'">￥<span>{{erwalifytr.MARKET_PRICE}}</span></p>
              <p class="Wafopant-comdity-right-Excicele" v-else-if="maluerID == '1'"><span>{{erwalifytr.SCORE_PRICE}}</span></p>
              <p class="Wafopant-comdity-right-Excicerg">x{{erwalifytr.SHOP_NUMBER}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="Wafopant-Ordetion">
          <p v-if="maluerID == '0'"><span>商品总额:</span>{{waredots.MARKET_HJPRICE}}</p>
          <p v-else-if="maluerID == '1'"><span>商品总额:</span>{{waredots.SCORE_HJPRICE}}</p>
          <p><span>运费:</span>包邮</p>
          <p v-if="maluerID == '0'"><span>应付:</span>{{waredots.ACTUAL_PAYMENT || waredots.MARKET_HJPRICE}}</p>
          <p v-else-if="maluerID == '1'"><span>应付:</span>{{waredots.ACTUAL_PAYMENT || waredots.SCORE_HJPRICE}}</p>
      </div>
      <div class="Wafopant-Ordetion">
          <p><span>订单编号:</span>{{waredots.CODING}}</p>
          <p><span>下单时间:</span>{{waredots.PLACE_ORDER_DATE}}</p>
          <p v-if="waredots.SHOP_STATE">
            <span>付款方式:</span>
            <span v-if="waredots.SHOP_STATE == '0'">微信</span>
            <span v-else-if="waredots.SHOP_STATE == '1'">支付宝</span>
            <span v-else-if="waredots.SHOP_STATE == '2'">一卡通余额{{waredots.PAYCNUMBER ? '(' + waredots.PAYCNUMBER + ')' : ''}}</span>
            <span v-else-if="waredots.SHOP_STATE == '3'">一卡通积分{{waredots.PAYCNUMBER ? '(' + waredots.PAYCNUMBER + ')' : ''}}</span>
            <span v-else-if="waredots.SHOP_STATE == '4'">消费积分</span>
          </p>
      </div>
      <div class="Wafopant-fill"></div>
      <div class="Wafopant-Topay" v-if="waredots.ORDER_STATE == '0'">
        <button class="Wafopant-Topay-left" @click="Wafoaddess()">取消订单</button>
        <router-link :to="{path:'Ordesion',query: {waoderID: this.waOrails,fimaue: this.waredots.MARKET_HJPRICE,fimece: this.waredots.MEMBER_HJPRICE,fiinpr: this.waredots.NTEGRAL_HJPRICE}}" v-if="maluerID == '0'"><button class="Wafopant-Topay-right">去支付</button></router-link>
        <router-link :to="{path:'Ordesion',query: {waoderID: this.waOrails,fimaue: this.waredots.SCORE_HJPRICE}}" v-else-if="maluerID == '1'"><button class="Wafopant-Topay-right">去支付</button></router-link>
      </div>
      <div class="Wafopant-Topay" v-else-if="waredots.ORDER_STATE == '1' && maluerID == '0'">
        <button class="Wafopant-Topay-left" @click="Waplyund()">申请退款</button>
      </div>
      <div class="Wafopant-Topay" v-else-if="waredots.ORDER_STATE == '2'">
        <button class="Wafopant-Topay-right" @click="WaConipt()">确认收货</button>
      </div>
      <!-- <div class="Wafopant-Topay" v-if="waoryftion.ORDER_STATE == '0'">
        <button class="Wafopant-Topay-left" @click="Wafoaddess()">取消订单</button>
        <router-link :to="{path:'Ordesion',query: {FiAderID: waoryftion.ID,FiSpnsID: waoryftion.SPECIF_ID,FiPrtity: waoryftion.SHOP_NUMBER}}"><button class="Wafopant-Topay-right">去支付</button></router-link>
      </div>
      <div class="Wafopant-Topay" v-else-if="waoryftion.ORDER_STATE == '1'">
        <button class="Wafopant-Topay-left" @click="Wafoaddess()">申请退款</button>
        <router-link :to="{path:'commodity',query:{hmComyID: waoryftion.GOODS_ID}}"><button class="Wafopant-Topay-right">再次购买</button></router-link>
      </div>
      <div class="Wafopant-Topay" v-else-if="waoryftion.ORDER_STATE == '2'">
        <button class="Wafopant-Topay-left" @click="Wafoaddess()">申请退款</button>
        <button class="Wafopant-Topay-right" @click="WaConipt()">确认收货</button>
      </div>
      <div class="Wafopant-Topay" v-else-if="waoryftion.ORDER_STATE == '3'">
        <router-link :to="{path:'commodity',query:{hmComyID: waoryftion.GOODS_ID}}"><button class="Wafopant-Topay-right">再次购买</button></router-link>
      </div>
      <div class="Wafopant-Topay" v-else-if="waoryftion.ORDER_STATE == '4'">
        <button class="Wafopant-Topay-left" @click="Wafoaddess()">退货/售后</button>
        <router-link :to="{path:'commodity',query:{hmComyID: waoryftion.GOODS_ID}}"><button class="Wafopant-Topay-right">再次购买</button></router-link>
      </div> -->
    </div>
    <!-- 选择地址弹框 -->
    <div class="Wafopant-Mask" :style="'display:' + Wafotyse" @click="Wafodime()"></div>
    <div class="Wafopant-frame" :style="'display:' + Wafofrse">
      <div class="Wafopant-Seless-titlt">
        取消订单
        <img src="../../public/obraoag/commodityclose.png" alt="" @click="Wafoseltlt()">
      </div>
      <div class="Wafopant-Canmpt">
        <p class="Wafopant-Canmpt-title">温馨提示:</p>
        <p class="Wafopant-Canmpt-text">1.限时特价、预约资格等购买优惠可能被取消</p>
        <p class="Wafopant-Canmpt-text">2.如遇订单拆分,京券将换成同价值京豆返回</p>
        <p class="Wafopant-Canmpt-text">3.支付券不予返还;支付优惠一并取消</p>
        <p class="Wafopant-Canmpt-text">4.订单一旦取消,无法恢复</p>
      </div>
      <div class="Wafopant-Manory">请选择取消订单的原因(必选):</div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoWrss"></el-checkbox>
        <span class="Wafopant-Reaion-text">地址填写错误</span>
      </div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoNore"></el-checkbox>
        <span class="Wafopant-Reaion-text">不想要了</span>
      </div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoMuts"></el-checkbox>
        <span class="Wafopant-Reaion-text">商品错选/多选</span>
      </div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoThck"></el-checkbox>
        <span class="Wafopant-Reaion-text">商品无货</span>
      </div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoCoon"></el-checkbox>
        <span class="Wafopant-Reaion-text">商品降价</span>
      </div>
      <div class="Wafopant-Reaion">
        <el-checkbox v-model="WafoFont"></el-checkbox>
        <span class="Wafopant-Reaion-text">没用,少用/错用优惠</span>
      </div>
      <button class="Wafopant-frame-confirm" @click="wacelndr()">提交</button>
    </div>
    <!-- 微信WeUI插件 -->
    <div class="js_dialog" id="iosDialog1" :style="'display:' + WafoAnyrules">
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div><strong class="weui-dialog__title" id="js_title1">提示</strong></div>
        <div class="weui-dialog__bd">{{waoperps}}</div>
        <div class="weui-dialog__ft" v-if="waredots.ORDER_STATE == '1'">
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="WafocancelButton()">我再想想</a>
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="waaplfod()" style="color: #F40A15;">申请退款</a>
        </div>
        <div class="weui-dialog__ft" v-else-if="waredots.ORDER_STATE == '2'">
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_default" @click="Wagdsved()">未收到货</a>
          <a role="button" href="javascript:" class="weui-dialog__btn weui-dialog__btn_primary" @click="warevgod()" style="color: #F40A15;">已收到货</a>
        </div>
      </div>
    </div>
    <!-- 错误提示 -->
    <Errosage :style="'display:' + warierge" :txtrro="this.waersg"></Errosage>
    <!-- 成功提示 -->
    <Succtips :style="'display:' + warisups"></Succtips>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      Wafotyse: 'none',
      Wafofrse: 'none',
      WafoWrss: false,
      WafoNore: false,
      WafoMuts: false,
      WafoThck: false,
      WafoCoon: false,
      WafoFont: false,
      waOrails: '',
      waAdfion: '',
      WafoAnyrules: 'none',
      waredots: '',
      walifytr: '',
      warierge: 'none',
      warisups: 'none',
      waersg: '',
      waoperps: '',
      maluerID: '',
      waistaon: ''
    }
  },
  created(){
    // 从缓存中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    // 从缓冲中获取商城的标识
    this.maluerID = localStorage.getItem("usmago");
    // 接收订单列表传过来的ID
    this.waOrails = this.$route.query.myOrails;
    // 通过拼接ID获取订单信息
    this.$axios.post('app/mallOrderDetails',this.$qs.stringify({
      ID: this.waOrails,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.waredots = res.data;
      this.walifytr = res.data.shop;
      this.waistaon = res.data.shop[0].IS_NOT_COUPONS;
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
    // 通过拼接用户ID获取用户地址信息
    this.$axios.post('wx/addressList',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      MALL_TYPE: this.maluerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.waAdfion = res.data.default[0] || '';
    })
    .catch(() => {
      // console.log('未登录获取数据失败');
    });
  },
  mounted(){
     
  },
  methods:{
    // 取消订单
    Wafoaddess(){
      this.Wafotyse = 'block';
      this.Wafofrse = 'block';
    },
    // 点击知道了隐藏提示弹框
    WafocancelButton(){
      this.WafoAnyrules = 'none';
    },
    // 点击关闭取消订单
    Wafoseltlt(){
      this.Wafotyse = 'none';
      this.Wafofrse = 'none';
    },
    // 点击遮罩取消订单
    Wafodime(){
      this.Wafotyse = 'none';
      this.Wafofrse = 'none';
    },
    // 取消订单
    wacelndr(){
      if(this.WafoWrss || this.WafoNore || this.WafoMuts || this.WafoThck || this.WafoCoon || this.WafoFont){
        this.$axios.post('wx/updateOrderState',this.$qs.stringify({
          ID: this.waOrails,
          ORDER_STATE: '3',
          MALL_TYPE: this.maluerID
        }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
        .then(res => {
          if(res.data.result == 'success'){
            this.warisups = 'block';
            const _this = this;
            setTimeout(function(){
              _this.warisups = 'none';
              _this.$router.push({name: 'Myorder', query: {myTobeid: '0'}});
            },1200)
          }
        })
        .catch(() => {
            // console.log('未登录获取数据失败');
        });
      }else{
        this.waersg = '请选择要取消订单的原因';
        this.warierge = 'block';
        const _this = this;
        setTimeout(function(){
          _this.warierge = 'none';
        },1200)
      }
    },
    // 申请退款
    Waplyund(){
      this.waoperps = '您确认要申请退款吗?';
      this.WafoAnyrules = 'block';
    },
    // 点击申请退款触发
    waaplfod(){
      this.WafoAnyrules = 'none';
      this.$axios.post('app/mallrefundapplication',this.$qs.stringify({
        MEMBER_ID: this.customerID,
        ORDER_ID: this.waOrails,
        AMOUNT: this.waredots.ACTUAL_PAYMENT,
        MALL_TYPE: this.maluerID
      }),{headers:{'token': this.customerID}})
      .then(res => {
        if(res.data.result == 'success'){
          this.warisups = 'block';
          const _this = this;
          setTimeout(function(){
            _this.warisups = 'none';
            _this.$router.push({name: 'Myorder', query: {myTobeid: '0'}});
          },1200)
        }
      })
      .catch(() => {
          // console.log('未登录获取数据失败');
      });
    },
    // 点击确认收货
    WaConipt(){
      this.waoperps = '请确认是否已收到货?';
      this.WafoAnyrules = 'block';
    },
    // 点击未收到货触发
    Wagdsved(){
      this.WafoAnyrules = 'none';
      this.$router.push({name: 'Myorder', query: {myTobeid: '3'}});
    },
    // 点击已收到货触发
    warevgod(){
      this.WafoAnyrules = 'none';
      this.$axios.post('wx/updateOrderState',this.$qs.stringify({
        ORDER_STATE: '4',
        ID: this.waOrails,
        MALL_TYPE: this.maluerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.result == 'success'){
          this.warisups = 'block';
          const _this = this;
          setTimeout(function(){
            _this.warisups = 'none';
            _this.$router.push({name: 'Myorder', query: {myTobeid: '5'}});
          },1200)
        }
      })
      .catch(() => {
          // console.log('未登录获取数据失败');
      });
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/Wafopant.css";
</style>